import { calculateHours } from "./timeUtils";
import { isShiftBillable, getShiftRole } from "./shiftEngine";

function getShiftStart(shift) {
  return shift?.start || shift?.startTime || null;
}

function getShiftEnd(shift) {
  return shift?.end || shift?.endTime || null;
}

export function getShiftBillRate(shift) {
  return (
    Number(shift?.billRate || 0) ||
    Number(shift?.rates?.billRate || 0) ||
    Number(shift?.billingRate || 0) ||
    Number(shift?.facilityBillRate || 0) ||
    0
  );
}

export function calculateShiftBillAmount(shift) {
  const hours = calculateHours(getShiftStart(shift), getShiftEnd(shift));
  const rate = getShiftBillRate(shift);

  return Math.round(hours * rate * 100) / 100;
}

export function buildInvoiceLineItem(shift) {
  const start = getShiftStart(shift);
  const end = getShiftEnd(shift);
  const hours = calculateHours(start, end);
  const billRate = getShiftBillRate(shift);

  return {
    shiftId: shift?.id || shift?.shiftId || "",
    facilityId: shift?.facilityId || "",
    role: getShiftRole(shift),
    start,
    end,
    hours,
    billRate,
    amount: Math.round(hours * billRate * 100) / 100,
  };
}

export function buildInvoiceLineItems(shifts = []) {
  return shifts
    .filter((shift) => isShiftBillable(shift))
    .map((shift) => buildInvoiceLineItem(shift));
}

export function calculateInvoiceSubtotal(lineItems = []) {
  const subtotal = lineItems.reduce((total, item) => {
    return total + Number(item?.amount || 0);
  }, 0);

  return Math.round(subtotal * 100) / 100;
}

export function calculateInvoiceTotals(lineItems = [], options = {}) {
  const subtotal = calculateInvoiceSubtotal(lineItems);
  const taxRate = Number(options?.taxRate || 0);
  const discount = Number(options?.discount || 0);

  const tax = subtotal * taxRate;
  const total = subtotal + tax - discount;

  return {
    subtotal: Math.round(subtotal * 100) / 100,
    tax: Math.round(tax * 100) / 100,
    discount: Math.round(discount * 100) / 100,
    total: Math.round(total * 100) / 100,
  };
}

export function buildInvoicePayload({
  facilityId,
  facilityName,
  shifts = [],
  invoiceNumber,
  issueDate,
  dueDate,
  options = {},
}) {
  const lineItems = buildInvoiceLineItems(shifts);
  const totals = calculateInvoiceTotals(lineItems, options);

  return {
    invoiceNumber: invoiceNumber || "",
    facilityId: facilityId || "",
    facilityName: facilityName || "",
    issueDate: issueDate || new Date().toISOString(),
    dueDate: dueDate || null,
    status: "draft",
    lineItems,
    totals,
    createdAt: new Date().toISOString(),
  };
}